<template>
  <div class="module container_lg moduleThree">

    <div class="scene">

      <!-- backdrops -->
      <library-back-drop></library-back-drop>

      <div class="layer">
        <!-- <empty-back-drop></empty-back-drop> -->
        <schoolHallwaySecond />
      </div>

      <div class="layer">
        <second-empty-back-drop></second-empty-back-drop>
      </div>

      <!-- characters -->
      <div class="layer">
        <hailey :data="haileyData"></hailey>
        <reece :data="reeceData"></reece>
        <devyn :data="devynData"></devyn>
        <aye :data="ayeData"></aye>
        <ria :data="riaData"></ria>
      </div>

      <!-- doors -->
      <div class="layer">
        <library-doors :data="libraryDoorsData" :showOnEdge="showDoorsOnEdge"></library-doors>
      </div>

    </div>

    <!-- popup modal -->
    <div class="layer layer-full index-2" :class="modalLayerClass">
      <modal :active="modalActive" v-on:close="closeModalLayer" :text="modalText" :ind="modalInd" :modalStyle="modalStyle"></modal>
    </div>

    <control-panel :text="activeText" :control_panel_active="controlPanelActive" v-on:textProgress="updateScene"></control-panel>

  </div>
</template>

<style lang="scss">
  @import './scss/module3';

</style>

<style scoped lang="scss">
  .scene {
    margin: auto;
    // overflow-x: scroll !important; // for debugging
  }

  .layer,
  .scene {
    max-width: 1280px;
    &.layer-full {
      max-width: 100%;
    }
  }

  .layer {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .index-2 {
    z-index: 2
  }

  .layer-inactive {
    pointer-events: none;
  }

</style>

<script>
  import anime from 'animejs';
  import animations from '@/assets/js/animations';
  import * as contentful from 'contentful';

  // components
  import libraryDoors from './svg/libraryDoors'
  import libraryBackDrop from './svg/libraryBackDrop'
  import emptyBackDrop from './svg/emptyBackDrop'
  import secondEmptyBackDrop from './svg/emptySecondBackDrop'
  import schoolHallwaySecond from './svg/schoolHallwaySecond'
  import ria from './svg/ria'
  import aye from './svg/aye'
  import devyn from './svg/devyn'
  import hailey from './svg/hailey'
  import reece from './svg/reece'

  // sandbox animations
  import {
    SANDBOX
  } from './js/SANDBOX'
  // actual slides
  import {
    slides
  } from './js/slides'

  export default {
    data() {
      return {
        showDoorsOnEdge: true, // edge workaround.
        text: null,
        activeText: {
          string: ''
        },
        controlPanelActive: true,
        backDropTranslate: 0,
        currentSlideIndex: 0,
        riaData: {
          speaking: false,
        },
        devynData: {
          speaking: false,
          look_back: false,
          // todo: remove flipped class and handle in animejs
        },
        haileyData: {
          speaking: false,
          look_up: false
        },
        reeceData: {
          speaking: false,
          look_up: false
        },
        ayeData: ["neutral", "yellow"],
        libraryDoorsData: {
          leftDoorClass: '',
          rightDoorClass: '',
          lineOne: 'MODULE 3:',
          lineTwo: 'Love and Respect',
          clickHandler: this.updateScene,
          showOpenButton: true
        },
        modalText: [
          [
            "Before you launch the animation, please assign the following speaking roles to students in the classroom. Readers will know it is their turn to speak when their character’s icon appears to the left of the text box.",
            "Student One: Aye", "Student Two: Ria", "Student Three: Devyn", "Student Four: Hailey",
            "Student Five: Reece"
          ],
          [
            "Students, as Aye is looking for students to interview about love, why don’t you discuss your thoughts as a class.  Please see your teacher for the first activity."
          ],
          [
            "Now that you have discussed love and seen what some of the students at Aye’s school think of love, please see your teacher for an activity to look at the attributes found in all healthy relationships and how healthy romantic relationships are built. Please click to proceed once you have completed the exercise"
          ]
        ],
        modalActive: false,
        modalInd: 0,
        modalLayerClass: {
          'layer-inactive': true
        },
        modalStyle: {
          'background': '#BFE298'
        }
      }
    },
    methods: {
      updateScene() {
        // SANDBOX(this)
        if (this.currentSlideIndex < 1) this.openDoors() // open doors initially
        if (this.currentSlideIndex === slides.length - 1) this.closeDoors() // close doors on last slide  
        if (this.currentSlideIndex > slides.length - 1) return false // error handling
        slides[this.currentSlideIndex](this) // call animation
      },
      // doors
      openDoors() {
        let door_sound = new Audio('static/audio/module_1/door_open.wav')
        door_sound.play()
        anime({
          targets: '.left-library-door',
          translateX: '-125%',
          easing: 'easeOutQuart',
          duration: 2000
        })
        anime({
          targets: '.right-library-door',
          translateX: '125%',
          easing: 'easeOutQuart',
          duration: 2000,
          complete: () => {
            this.showDoorsOnEdge = false
          }
        })
      },
      closeDoors() {
        let door_sound = new Audio('static/audio/module_1/door_open.wav')
        door_sound.play()
        this.libraryDoorsData.showOpenButton = false // hide 'Push to Open' button
        anime({
          targets: '.left-library-door',
          translateX: '0%',
          easing: 'easeOutQuart',
          duration: 2000
        })
        anime({
          targets: '.right-library-door',
          translateX: '0%',
          easing: 'easeOutQuart',
          duration: 2000,
          begin: () => {
            this.showDoorsOnEdge = true
          }
        })
      },
      // modal
      toggleModalLayer(bool) {
        this.modalActive = bool
        this.modalLayerClass["layer-inactive"] = !bool
      },
      openModalLayer() { // aliases for toggleModalLayer
        this.toggleModalLayer(true)
      },
      closeModalLayer() {
        this.toggleModalLayer(false)
      },
    },
    components: {
      "library-doors": libraryDoors,
      "library-back-drop": libraryBackDrop,
      "empty-back-drop": emptyBackDrop,
      "second-empty-back-drop": secondEmptyBackDrop,
      "ria": ria,
      "aye": aye,
      "devyn": devyn,
      "hailey": hailey,
      "reece": reece,
      schoolHallwaySecond
    },
    mounted() {

      this.activeText = {
        string: 'Location: School'
      }

      this.openModalLayer() // play modal transition on load

      // init contentful
      const content_client = contentful.createClient({
        space: process.env.SPACE_ID,
        accessToken: process.env.CMS_TOKEN
      })

      content_client.getEntries({
          content_type: 'module',
          'fields.module_number': 3
        })
        .then((response) => {
          this.text = response.items[0].fields.module_text.map((data) => {
            let temp;
            if (data.fields.speaker) {
              temp = {
                id: data.fields.id,
                speaker: data.fields.speaker,
                string: data.fields.text ? data.fields.text.replace(/\n/g, "<br/>") : ""
              }
            } else {
              temp = {
                id: data.fields.id,
                string: data.fields.text ? data.fields.text.replace(/\n/g, "<br/>") : ""
              }
            }
            // console.log(temp)
            return temp
          })
        })
        .catch(console.error)
    }
  }

</script>



// WEBPACK FOOTER //
// module_3.vue?1349909b